import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import PostByAgg from "../utils/axios";
import { useAuth } from "../context/AuthContext";
import Cookies from "js-cookie"
import { useNavigate } from "react-router-dom";

const OtpModal = ({ show, onClose, onSuccess, apiMessage }) => {
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(120); 
  const [error, setError] = useState("");
  //const [otpCount, setOtpCount] = useState(3); 
  const [loading, setLoading] = useState(false);
//   const MAX_OTP_ATTEMPTS = 3; // Atur jumlah maksimum percobaan OTP
 const [otpCount, setOtpCount] = useState(3);

 const {email, setRoleCode, setIsLoggedIn, setRoleName} = useAuth()
 const navigate = useNavigate()


  useEffect(() => {
    if (!show) return;

    setOtp(""); 
    setError("");
    setTimer(120);

    const countdown = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(countdown);
          setError("Waktu habis. Silakan login ulang.");
          setTimeout(() => {
            onClose();
          }, 2000);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(countdown);
  }, [show]);

 
 const handleSubmit = async () => {
     if (!otp) {
         setError("Mohon masukkan OTP");
         return;
     }
 
     setLoading(true); // Start loading
 
     const url = 'user/um/v1/validate-OTP';
     
     PostByAgg({
         url: url,
         body: {
             'otp_code': otp,
             'otp_count': String(otpCount),
             'email': email
         },
         onResponse: onVerifyOtpResponse,
         onError: onVerifyOtpError,
     });
 
     function onVerifyOtpResponse(response) {
         console.log("Verify OTP Response:", response.data);
         console.log("roleCode:", response.data.code);
         if (response && response.data && response.data.code === "2002000") {
          const roleCode = response.data.data.role_code;
          const roleName = response.data.data.role_name;
  
          // Simpan data ke cookies
          Cookies.set("email", email);
          Cookies.set("roleCode", roleCode);
          Cookies.set("roleName", roleName);
          Cookies.set("isLoggedIn", true);
  
          // Simpan data ke AuthContext
          setRoleCode(roleCode);
          setRoleName(roleName);
          setIsLoggedIn(true);
          onSuccess()
         } else {
             handleOtpFailure(response.data.message.id);
         }
     }
 
     function onVerifyOtpError(error) {
         console.error("Verify OTP Error:", error);
         if (error.response && error.response.data) {
          setError(error.response.data.message.id || "Terjadi kesalahan saat memverifikasi OTP.");
      } else {
          setError("Terjadi kesalahan tidak terduga.");
      }
         setLoading(false);
         handleOtpFailure("OTP tidak valid.");
     }
 
     function handleOtpFailure(errorMessage) {
         setOtpCount((prevCount) => {
             const newCount = prevCount - 1;
             
             if (newCount <= 0) {
              setError("Kesempatan OTP habis. Silakan login ulang.");
              
              // Clear cookies dan redirect ke login jika OTP habis
              setTimeout(() => {
                Cookies.remove("email");
                Cookies.remove("roleCode");
                Cookies.remove("roleName");
                Cookies.remove("isLoggedIn");
                navigate("/login");
              }, 2000);
            } else {
              setError(errorMessage + ` (${newCount} kesempatan tersisa)`);
            }
    
            return newCount;
          });
        }
 };


  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false} centered className="shadow-lg rounded p-3 mb-5">
      <Modal.Header className="border-0" closeButton>
        <Modal.Title className="font-weight-bold">Input OTP</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <p className="text-center">
          Kode OTP telah dikirim ke <strong>{email}</strong>
        </p> */}
        {apiMessage && <p className="text-success text-center">{apiMessage}:</p>}
        <p className="text-center">
            <strong>{email}</strong>
        </p>
        <p className="text-danger text-center">
          Waktu tersisa: <strong>{Math.floor(timer / 60)}:{String(timer % 60).padStart(2, "0")}</strong>
        </p>
        {/* <p className="text-danger text-center">
            {otpCount > 0 ? `Kesempatan tersisa ${otpCount} kali.` : `Kesempatan tersisa ${otpCount} kali.`}
        </p> */}
        {error && <div className="alert alert-danger">{error}</div>}
        <input
            type="text"
            className="form-control"
            placeholder="Masukkan OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            autoFocus
        />
      </Modal.Body>
      <Modal.Footer className="border-0">
        <button className="btn btn-secondary" onClick={onClose}>Batal</button>
        <button className="btn btn-dark" onClick={handleSubmit}>Verifikasi</button>
      </Modal.Footer>
    </Modal>
  );
};

export default OtpModal;
